export default "__VITE_ASSET__BVf4Vkvu__"